module.exports = __webpack_public_path__ + "static/media/play.e3f3c812.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/play.png
// module id = 95
// module chunks = 0